export const translations = {
  en: {
    nav: { services: "Services", how: "How it works", blog: "Blog", contact: "Contact", download: "Download App" },
    hero: {
      badge: "Home services",
      title1: "Local services,",
      title2: "simple and fast.",
      subtitle: "Giva Solution connects you to trusted service providers in your area. Gas, car, motorbike support, repairs and more, all from your app.",
      how: "How it works",
      rating: "Professionals rated by the community",
      secure: "Secure payment",
      secureSub: "Directly in the app",
    },
    download: { app: "Download on the", appstore: "App Store", play: "Get it on", googleplay: "Google Play" },
    services: {
      overline: "What we offer",
      title: "Everything you need, in one place.",
      subtitle: "Search services by category and find trusted professionals across different areas.",
      items: [
        { title: "Gas", desc: "Gas bottle delivery and home support." },
        { title: "Car", desc: "Car help and maintenance services." },
        { title: "Motorbike", desc: "Motorbike support and maintenance." },
        { title: "Device Repair", desc: "Smartphones, tablets and electronics repaired by specialists." },
        { title: "Keys & Locks", desc: "Trusted locksmith service, whenever you need it." },
        { title: "Pickup & Delivery", desc: "We collect your item and return it to the comfort of your home." },
        { title: "On-site Visit", desc: "Professionals who come to you to get everything done." },
      ],
    },
    steps: {
      overline: "As simple as it should be",
      title: "In three steps.",
      items: [
        { title: "Choose the service", desc: "Search by category and easily find the right professional for your need." },
        { title: "Schedule or request pickup", desc: "Choose between pickup & delivery, self-service or on-site visit. You decide." },
        { title: "Track & pay", desc: "Communicate directly with the provider and pay quickly and securely in the app." },
      ],
    },
    provider: {
      badge: "For providers",
      title: "Are you a professional? Register and increase your income with Giva Solutions.",
      subtitle: "Join the GIVA provider network, receive requests in your area and grow your business.",
      cta: "Contact us to join",
    },
    driverEarn: {
      badge: "For drivers",
      title: "Want to earn extra income? Drive and earn with Giva Driver.",
      subtitle: "Deliver with Giva Driver, accept nearby requests and earn on your own schedule.",
      cta: "Download Giva Driver",
    },
    blogPreview: { overline: "From our blog", title: "News & guides", seeAll: "See all" },
    contact: {
      overline: "Get in touch",
      title: "Have a question?",
      subtitle: "Send us a message and our team will get back to you as soon as possible.",
      providerHint: "Professionals and local service providers can use this form to ask about joining Giva Solutions.",
      name: "Name", email: "Email", message: "Message",
      namePh: "Your name", emailPh: "email@example.com", messagePh: "How can we help?",
      send: "Send message", sending: "Sending...", success: "Message sent successfully!",
      phone: "Phone", supportEmail: "Support email",
    },
    footer: {
      tagline: "The platform that connects users to local service providers simply, quickly and securely.",
      nav: "Navigation", company: "Company", access: "Access",
      driver: "Giva Driver", privacy: "Privacy Policy", admin: "Admin Area", website: "Website",
      rights: "All rights reserved.", slogan: "Home services, fast.",
    },
    blogPage: {
      overline: "GIVA Blog", title: "News & guides",
      subtitle: "Tips, stories and everything you need to know about home services.",
      empty: "No articles published yet.", read: "Read article",
    },
    post: { back: "Back to blog", notFound: "Article not found." },
    admin: {
      login: { back: "Back to site", title: "Admin Area", subtitle: "GIVA blog management", email: "Email", password: "Password", submit: "Sign in", success: "Signed in", fail: "Sign-in failed" },
      dash: {
        panel: "GIVA Panel", viewSite: "View site", logout: "Sign out", title: "Blog Management",
        articles: "article(s)", loading: "Loading...", new: "New article",
        emptyT: "No articles yet", emptyD: "Create your first article to get started.",
        colArticle: "Article", colCategory: "Category", colStatus: "Status", colActions: "Actions",
        published: "Published", draft: "Draft",
        confirmDelete: "Are you sure you want to delete this article?", deleted: "Article deleted",
      },
      editor: {
        newT: "New article", editT: "Edit article", title: "Title", titlePh: "Article title",
        category: "Category", categoryPh: "e.g. Guides", author: "Author",
        cover: "Cover image (URL)", excerpt: "Excerpt", excerptPh: "Brief description of the article",
        content: "Content", contentPh: "Write the article content. Separate paragraphs with a blank line.",
        publishedLabel: "Published (visible on site)", cancel: "Cancel", save: "Save",
        created: "Article created", updated: "Article updated", titleRequired: "Title is required", preview: "Preview",
      },
    },
  },

  pt: {
    nav: { services: "Serviços", how: "Como funciona", blog: "Blog", contact: "Contacto", download: "Descarregar App" },
    hero: {
      badge: "Serviços ao domicílio",
      title1: "Serviços locais,",
      title2: "simples e rápidos.",
      subtitle: "A Giva Solution conecta-o a prestadores de serviços de confiança na sua zona. Gás, carro, mota, reparações e muito mais, tudo a partir da sua app.",
      how: "Como funciona",
      rating: "Profissionais avaliados pela comunidade",
      secure: "Pagamento seguro",
      secureSub: "Direto na aplicação",
    },
    download: { app: "Disponível na", appstore: "App Store", play: "Disponível no", googleplay: "Google Play" },
    services: {
      overline: "O que oferecemos",
      title: "Tudo o que precisa, num só lugar.",
      subtitle: "Pesquise serviços por categoria e encontre profissionais de confiança em diferentes áreas.",
      items: [
        { title: "Gás", desc: "Entrega de botijas de gás e apoio ao domicílio." },
        { title: "Carro", desc: "Ajuda e manutenção para automóveis." },
        { title: "Mota", desc: "Apoio e manutenção para motas." },
        { title: "Reparação de Dispositivos", desc: "Smartphones, tablets e eletrónica reparados por especialistas." },
        { title: "Chaves & Fechaduras", desc: "Serviço de chaveiro de confiança, sempre que precisar." },
        { title: "Recolha & Entrega", desc: "Recolhemos o seu item e devolvemos no conforto da sua casa." },
        { title: "Visita no Local", desc: "Profissionais que se deslocam até si para resolver tudo." },
      ],
    },
    steps: {
      overline: "Simples como deve ser",
      title: "Em três passos.",
      items: [
        { title: "Escolha o serviço", desc: "Pesquise por categoria e encontre facilmente o profissional certo para a sua necessidade." },
        { title: "Agende ou solicite recolha", desc: "Escolha entre recolha & entrega, autoatendimento ou visita no local. Você decide." },
        { title: "Acompanhe & pague", desc: "Comunique diretamente com o prestador e pague de forma rápida e segura na app." },
      ],
    },
    provider: {
      badge: "Para prestadores",
      title: "É profissional? Registe-se e aumente o seu rendimento com a Giva Solutions.",
      subtitle: "Junte-se à rede de prestadores GIVA, receba pedidos na sua zona e faça crescer o seu negócio.",
      cta: "Contacte-nos para aderir",
    },
    driverEarn: {
      badge: "Para motoristas",
      title: "Quer ganhar rendimento extra? Conduza e ganhe com a Giva Driver.",
      subtitle: "Faça entregas com a Giva Driver, aceite pedidos próximos e ganhe no seu próprio horário.",
      cta: "Descarregar Giva Driver",
    },
    blogPreview: { overline: "Do nosso blog", title: "Novidades & guias", seeAll: "Ver todos" },
    contact: {
      overline: "Fale connosco",
      title: "Tem alguma questão?",
      subtitle: "Envie-nos uma mensagem e a nossa equipa entrará em contacto consigo o mais breve possível.",
      providerHint: "Profissionais e prestadores locais podem usar este formulário para pedir adesão à Giva Solutions.",
      name: "Nome", email: "Email", message: "Mensagem",
      namePh: "O seu nome", emailPh: "email@exemplo.com", messagePh: "Como podemos ajudar?",
      send: "Enviar mensagem", sending: "A enviar...", success: "Mensagem enviada com sucesso!",
      phone: "Telefone", supportEmail: "Email de apoio",
    },
    footer: {
      tagline: "A plataforma que conecta utilizadores a prestadores de serviços locais de forma simples, rápida e segura.",
      nav: "Navegação", company: "Empresa", access: "Acesso",
      driver: "Giva Driver", privacy: "Política de Privacidade", admin: "Área de Administração", website: "Website",
      rights: "Todos os direitos reservados.", slogan: "Serviços ao domicílio rápido.",
    },
    blogPage: {
      overline: "GIVA Blog", title: "Novidades & guias",
      subtitle: "Dicas, histórias e tudo o que precisa de saber sobre serviços ao domicílio.",
      empty: "Ainda não existem artigos publicados.", read: "Ler artigo",
    },
    post: { back: "Voltar ao blog", notFound: "Artigo não encontrado." },
    admin: {
      login: { back: "Voltar ao site", title: "Área de Administração", subtitle: "Gestão do blog GIVA", email: "Email", password: "Palavra-passe", submit: "Iniciar sessão", success: "Sessão iniciada", fail: "Falha ao iniciar sessão" },
      dash: {
        panel: "Painel GIVA", viewSite: "Ver site", logout: "Sair", title: "Gestão do Blog",
        articles: "artigo(s)", loading: "A carregar...", new: "Novo artigo",
        emptyT: "Ainda não há artigos", emptyD: "Crie o seu primeiro artigo para começar.",
        colArticle: "Artigo", colCategory: "Categoria", colStatus: "Estado", colActions: "Ações",
        published: "Publicado", draft: "Rascunho",
        confirmDelete: "Tem a certeza que pretende eliminar este artigo?", deleted: "Artigo eliminado",
      },
      editor: {
        newT: "Novo artigo", editT: "Editar artigo", title: "Título", titlePh: "Título do artigo",
        category: "Categoria", categoryPh: "Ex: Guias", author: "Autor",
        cover: "Imagem de capa (URL)", excerpt: "Resumo", excerptPh: "Breve descrição do artigo",
        content: "Conteúdo", contentPh: "Escreva o conteúdo do artigo. Separe parágrafos com uma linha em branco.",
        publishedLabel: "Publicado (visível no site)", cancel: "Cancelar", save: "Guardar",
        created: "Artigo criado", updated: "Artigo atualizado", titleRequired: "O título é obrigatório", preview: "Pré-visualização",
      },
    },
  },
};
